import React from "react";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import styles from "./styles";
import appConstants from "../../../../../appConstants";
import { withStyles } from "@material-ui/core/styles";
import { getServiceLevel, getServiceWindow } from "../../utils/utils";
import ViewStopImages from "./ViewStopImages"

const CollapsibleDetails = withStyles(styles)(({ classes, data, viewStopImages }) => {
  const getProDetails = () => {
    if (data.stopType === appConstants.STOP_TYPE.Pickup) {
      return {
        proDetailsLabel: "Pickup Number",
        proDetailsValue: data.pickupNumber ?? "",
      };
    }
    return {
      proDetailsLabel: "Pro Number(s)",
      proDetailsValue: data.shipments.map((pro) => pro.proId)?.join("; ") || "",
    };
  };
  const serviceLevel = getServiceLevel(data);
  const { proDetailsLabel, proDetailsValue } = getProDetails();
  return (
    <React.Fragment>
      <Table size="small">
        <TableBody>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableHeaderCell}>
              Service Window
            </TableCell>
            <TableCell className={classes.tableHeaderCell}>
              Service Level
            </TableCell>
            <TableCell className={classes.tableHeaderCell}>Bills</TableCell>
            <TableCell className={classes.tableHeaderCell}>HU</TableCell>
            <TableCell className={classes.tableHeaderCell}>Weight</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.enrouteTo}>
              {getServiceWindow({data})}
            </TableCell>
            <TableCell className={classes.tableDataCell}>
              {serviceLevel}
            </TableCell>
            <TableCell className={classes.tableDataCell}>
              {data.numberOfBills}
            </TableCell>
            <TableCell className={classes.tableDataCell}>{data.hu}</TableCell>
            <TableCell className={classes.tableDataCell}>
              {data.weight}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <div className={classes.proDetailsContainer}>
        <span className={classes.proDetailsHeaderCell}>{proDetailsLabel}</span>
        <span className={classes.proDetailsDataCell}>{proDetailsValue}</span>
      </div>
      <ViewStopImages onClick={viewStopImages}/>
    </React.Fragment>
  );
});

export default CollapsibleDetails;
